import axios from "axios";
import { getEnv } from "./environment";
import { pca } from "./index.js";

const env = getEnv();

const axiosInstance = axios.create({
  baseURL: env.url,
  headers: {
    "Content-Type": "application/json",
  },
});

//Request interceptor to add the token to every request
axiosInstance.interceptors.request.use(
  async (config) => {
    const accounts = pca.getAllAccounts();
    if (accounts.length > 0) {
      try {
        const response = await pca.acquireTokenSilent({
          account: accounts[0],
          scopes: [env.auth_scope],
        });
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      } catch (error) {
        console.error("Token acquisition failed", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
